<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container :fill-height="loading" class="user-settings" fluid pt-0>
    <v-app-bar app color="black" dark fixed>

      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button/>
      </template>

      <v-toolbar-title v-if="!loading" style="margin-left: 0">{{ $tc('valinta.title', 2) }}</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading">
        <v-col class="mt-2" cols="12" offset-xl="1" xl="10">
          <v-row>
            <v-col cols="12">
              <v-card color="#191919" outlined>
                <v-card-title primary-title>

                  {{ $tc('valinta.title', 2) }}
                  <v-spacer></v-spacer>

                  <v-btn color="primary" icon @click="openEdit(null)">
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                  <v-col cols="12" md="2">
                    <v-autocomplete v-model="vuosi" :items="vuodet" :label="$t('year')" hide-details></v-autocomplete>
                  </v-col>
                </v-card-text>
                <v-divider/>
                <v-card-text>
                  <valinta-table :valinnat="filteredValinnat"/>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="4" md="4">
              <v-card color="#191919">
                <v-card-title>
                  {{ $t('valinta.copy_next_year') }}
                </v-card-title>
                <v-divider/>
                <v-card-text>
                  <v-row class="mb-3">
                    <v-col cols="12">
                      <span class="text-subtitle-1">Mistä</span>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete v-model="copy.fromVastuualueId" :item-text="(item) => item.nimi"
                                      :items="vastuualueet"
                                      :label="$t('valinta.vastuualueelta')" hide-details item-value="id"/>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete v-model="copy.fromVuosi" :items="$years"
                                      :label="$t('valinta.vuodelta')" hide-details/>
                    </v-col>
                  </v-row>

                  <v-divider/>

                  <v-row class="mt-3">

                    <v-col cols="12">
                      <span class="text-subtitle-1">Mihin</span>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete v-model="copy.toVastuualueId" :item-text="(item) => item.nimi"
                                      :items="vastuualueet"
                                      :label="$t('valinta.vastuualueelle')" hide-details item-value="id"/>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete v-model="copy.toVuosi" :items="$years"
                                      :label="$t('valinta.vuodelle')" hide-details/>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="primary" @click="openCopyDialog">{{ $t('copy') }} ({{ filteredCopyValinnat.length }})
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-dialog v-model="copy.dialog" max-width="1200">
            <v-card>
              <v-card-title>
                {{ $t('valinta.kopioitavat_valinnat') }}
              </v-card-title>
              <v-divider/>
              <v-card-text>
                <v-alert class="mt-3" type="info">{{ $t('valinta.kopioidaan_myos_valintatyypit') }}</v-alert>
                <valinta-table :valinnat="filteredCopyValinnat" disable-edit/>
              </v-card-text>
              <v-divider/>
              <v-card-actions>
                <v-spacer/>
                <v-btn @click="copy.dialog = false">{{ $t('close') }}</v-btn>
                <v-btn color="primary" @click="copyValinnat">{{ $t('copy') }}</v-btn>
              </v-card-actions>
            </v-card>

          </v-dialog>
        </v-col>
      </v-row>
    </v-fade-transition>
  </v-container>
</template>

<script>
import api from '../apicollection';
import dayjs from 'dayjs'
import ValintaTable from "@/components/Valinta/ValintaTable";

export default {
  name: 'ValintaAsetuksetView',
  components: {ValintaTable},
  data() {
    return {
      loading: true,
      valinnat: [],
      vastuualueet: [],
      users: [],
      edit: {},
      vuosi: dayjs().year(),
      copy: {
        fromVastuualueId: null,
        toVastuualueId: null,
        fromVuosi: dayjs().add(-1, 'year').year(),
        toVuosi: dayjs().year(),
        dialog: false,
      },
      saving: false,
      showEditDialog: false,

    };
  },
  computed: {
    vuodet() {
      return this.$years;
    },
    filteredValinnat() {
      return this.valinnat.filter(v => v.vuosi === this.vuosi)
    },
    filteredCopyValinnat() {
      return this.valinnat
          .filter(v => v.vuosi === this.copy.fromVuosi && v.vastuualueId === this.copy.fromVastuualueId)
          .map(v => {
            return {
              ...v,
              vuosi: this.copy.toVuosi,
              vastuualue: this.vastuualueet.find(v => v.id === this.copy.toVastuualueId)
            }
          })
    },
  },
  methods: {
    async getValinnat() {
      const valinnat = await api.getValinnat();
      this.valinnat = valinnat;
    },
    async getVastuualueet() {
      const vastuualueet = await api.getVastuualueet();
      this.vastuualueet = vastuualueet;
    },
    async getUsers() {
      const users = await api.getUsers();
      this.users = users;
    },
    openCopyDialog() {
      if (!(this.copy.fromVastuualueId > 0 && this.copy.fromVuosi > 0 && this.copy.toVastuualueId > 0 && this.copy.toVuosi > 0)) return false;
      if (this.copy.fromVastuualueId === this.copy.toVastuualueId && this.copy.fromVuosi === this.copy.toVuosi) {
        this.$showWarningNotification(this.$t('errors.error_copying_valinta_no_same'));
        return false;
      }
      this.copy.dialog = true;
    },
    openEdit(item) {
      if (!item) {
        this.$router.push({name: 'asetukset_valinta_uusi'})
        return;
      }
      this.$router.push({name: 'asetukset_valinta_muokkaus', params: {id: item.id}})
    },
    async copyValinnat() {
      const body = {...this.copy}
      try {

        await api.copyValinnat(body);
        this.copy.dialog = false;
        this.$showSuccessNotification(this.$t('valinta.copy_success'))
        this.getValinnat();
        this.copy.toVastuualueId = null;
      } catch (e) {
        this.$showErrorNotification(this.$t('errors.error_saving_valinta'))
      } finally {
        this.saving = false;
      }
    },
    async save() {
      const valinta = {...this.edit};
      this.saving = true;
      if (valinta._logo) {
        valinta.logo = await this.$fileToBase64(valinta._logo);
      }
      try {
        if (valinta.id) {
          await api.updateValinta(valinta);
        } else {
          await api.createValinta(valinta);
        }

        this.closeDialog();
        this.getValinnat();
      } catch (e) {
        this.$showErrorNotification(this.$t('errors.error_saving_valinta'))
      } finally {
        this.saving = false;
      }
    }
  },
  async mounted() {
    await Promise.all([this.getValinnat(), this.getUsers(), this.getVastuualueet()])
    this.loading = false;
    this.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
    });
  },
};
</script>

<style lang="scss" scoped></style>
